module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAiElEQVQYGY3BwY3FIAxAwWdBH9APlGv6MX0YsbaUQxT9w84I/yR8uOkl1D6FF+HDTS+h9im8CA83vYTSBunsRap9CkF4uOkllDZIZy9S7VMI4qaXUNrgl7MXSdz0Ekob/HL2IgkPN72E0gbp7EWqfQpBeLjpJZQ2SGcvUu1TCMKHm15C7VN4+QOIIzUp2UZ08QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/flappybird/blink_02.png
// module id = 195
// module chunks = 0